<template>
  <div>
    <v-main>
      <div style="padding: 1.5rem;">
        <v-row>
          <v-col>
            <h2>การเชื่อมต่อ</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tabs v-model="tab" align-with-title style="margin-left:0px">
              <v-tabs-slider color="blue"></v-tabs-slider>

              <v-tab v-for="item in items" :key="item.name">
                {{ item.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat style="padding: 2rem;">
                  <div>
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2Fcropped-zort-logo-450.png?alt=media&token=7f7c434b-87c9-49e4-a773-19197b55f78b"
                      style="max-width:150px;max-height:150px">
                  </div>
                  <v-row style="padding-top: 20px;">
                    <v-col cols='4' style="background-color: #F7F7F7;">
                      <h4>
                        ขั้นตอนเชื่อมต่อ
                      </h4>
                      <p style="padding-left: 15px;">
                        1. เข้าสู่ระบบ <u><a href="https://secure.zortout.com/Integration/ApiReference" target="_blank">
                          Zort
                        </a></u>
                      </p>
                      <p style="padding-left: 15px;">
                        2. คัดลอกข้อมูลลิงก์ที่ได้
                      </p>
                      <p style="padding-left: 15px;">
                        3. นำลิงก์ที่ได้ไปกรอกที่ ตั้งค่า => เชื่อต่อบริการอื่น => Webhook => รายการขาย => UPDATEORDERPAYMENT
                      </p>
                      <p style="padding-left: 15px;">
                        4. กดปุ่ม ตรวจสอบและบันทึก
                      </p>

                    </v-col>
                    <v-col cols='5' style="background-color: #F7F7F7;">
                      <div ref="forminput">

                        <!-- <p style="margin: 0;">storename <span style="color: red;">*</span></p>
                        <v-text-field v-model="zort.storename" outlined dense></v-text-field>
                        <p style="margin: 0;">apikey <span style="color: red;">*</span></p>
                        <v-text-field v-model="zort.apikey" outlined dense></v-text-field>
                        <p style="margin: 0;">apisecret <span style="color: red;">*</span></p>
                        <v-text-field v-model="zort.apisecret" outlined dense></v-text-field>
                        <v-row>
                          <v-col class="text-right">
                            <v-btn class="ma-2" color="#1b437c" dark @click="submitZort()">
                              บันทึกข้อมูล
                            </v-btn>
                          </v-col>
                        </v-row> -->
                        <div style="width: 100%;display: flex;flex-direction: row;min-height: 40px;padding-top: 25px;">
                          <v-text-field v-model="linkZort" style="border-radius: 8px 0 0 8px;width:350px;" solo readonly
                            ref="textToCopy" height="40" placeholder='กรุณาเปิดการใช้งาน'></v-text-field>
                          <v-btn min-height="40" elevation="2" x-large color="success" dark
                            style="border-radius: 0 8px 8px 0;min-height: 40px" @click="textToCopy()">คัดลอก
                          </v-btn>
                        </div>

                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat style="padding: 2rem;">
                  <div>
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2Floyverse.png?alt=media&token=98daf6a9-882b-476a-aa80-7835fa8ff9e9"
                      style="max-width:150px;max-height:150px">
                  </div>
                  <v-row style="padding-top: 20px;">
                    <v-col cols='4' style="background-color: #F7F7F7;">
                      <h4>
                        ขั้นตอนเชื่อมต่อ
                      </h4>
                      <p style="padding-left: 15px;">
                        1. เข้าสู่ระบบ <u><a href="https://r.loyverse.com/dashboard/#/integrations/tokens" target="_blank">Loyverse</a></u>
                      </p>
                      <p style="padding-left: 15px;">2. สร้าง Access Token ที่เมนู integrations => Access tokens หลังจากนั้นกดปุ่ม ADD ACCESS TOKEN กรอกข้อมูลให้ครบถ้วนแล้วกด SAVE</p>
                      <p style="padding-left: 15px;">3. คัดลอกAccess tokenที่ได้มาวางที่ช่องด้านขวา บันทึกข้อมูล</p>
                      <p style="padding-left: 15px;">4. คัดลอกลิงก์ที่ได้ไปกรอกในระบบ <u><a href="https://r.loyverse.com/dashboard/#/webhooks" target="_blank">Loyverse</a></u></p>
                      <p style="padding-left: 15px;">5. กดปุ่มADD WEBHOOK เลือกEvent เป็น Receipt created or updated และนำลิงก์ที่คัดลอกกรอกใน URL กดปุ่มSAVE</p>
                    </v-col>
                    <v-col cols='5' style="background-color: #F7F7F7;">
                      <div ref="forminput">

                        <p style="margin: 0;">Access token <span style="color: red;">*</span></p>
                        <v-text-field v-model="loyverse.Access_token" outlined dense></v-text-field>
                        <v-row>

                          <v-col class="text-right">
                            <v-btn class="ma-2" color="#1b437c" dark @click="submitLoyverse()">
                              บันทึกข้อมูล
                            </v-btn>
                          </v-col>
                        </v-row>
                        <div style="width: 100%;display: flex;flex-direction: row;min-height: 40px;padding-top: 25px;"
                          v-show="linkLoyverse !== ''">
                          <v-text-field v-model="linkLoyverse" style="border-radius: 8px 0 0 8px;width:350px;" solo readonly
                            ref="textToCopy" height="40" placeholder='กรุณาเปิดการใช้งาน'></v-text-field>
                          <v-btn min-height="40" elevation="2" x-large color="success" dark
                            style="border-radius: 0 8px 8px 0;min-height: 40px" @click="textToCopy()">คัดลอก
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </div>
      <!-- <v-container class="pa-2" style="height: 100vh;"> -->

      <!-- <v-card elevation="2">
          <v-row class="pa-4 mt-3" justify="space-between">
            <v-col cols="3">
              <v-treeview :active.sync="active" :items="items" open-on-click rounded hoverable activatable>
                <template v-slot:label="{ item }">
                  <a @click="test(item)" style="display: flex;"><v-icon>{{ item.icon }}</v-icon>
                    <p class="mb-0" style="font-weight: 500;">{{ item.name }}</p>
                  </a>
                </template>
              </v-treeview>
            </v-col>

            <v-divider vertical></v-divider>

            <v-col style="display: flex;justify-content: center;">
              <v-scroll-y-transition mode="out-in">
                <div v-if="!selected2" class="text-h6 grey--text text--lighten-1 font-weight-light"
                  style="align-self: center;">
                  Select Menu
                </div>
                <v-card v-else :key="selected2.id"
                  style="display: flex;align-items: center;' : 'display: flex;"
                  flat max-width="600">
                  <v-card-text v-if="selected2.id === 1" style="justify-content: center;">
                    <v-btn style="background-color: #1b437c;" class="white--text mb-4" @click="createToken">สร้าง token
                      key</v-btn>
                    <div style="width: 400px;display: flex;">
                      <v-text-field v-model="apiToken" outlined dense label="token" ref="textToCopy"
                        prepend-inner-icon="mdi-key-variant"></v-text-field>
                      <div>
                        <v-btn class="mx-2" fab dark small color="primary" @click="textToCopy()">
                          <v-icon dark>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div style="width: 400px;display: flex;">
                      <v-text-field v-model="shopId" outlined dense label="shopId" ref="textToCopy2"
                        prepend-inner-icon="mdi-key-variant"></v-text-field>
                      <div>
                        <v-btn class="mx-2" fab dark small color="primary" @click="textToCopy2()">
                          <v-icon dark>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="selected2.id === 2">
                    <h2>Videocomplete api</h2>
                    - webhook API คือ event ต่างๆที่เกิดขึ้นกับ LINE Bot(Event trigger) โดยเมื่อ event
                    เกิดขึ้นแล้วจะมีสัญญาณพร้อมกับข้อมูลในรูปแบบที่เป็น JSON วิ่งมาที่ Webhook API ที่เราผูกไว้ใน LINE
                    Developers Console สามารถทำตามได้ตามลิ้ง<a
                      href="https://medium.com/linedevth/12-%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B8%93%E0%B8%88%E0%B8%B2%E0%B8%81-webhook-events-%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%88%E0%B8%B0%E0%B8%9B%E0%B8%A5%E0%B8%B8%E0%B8%81%E0%B9%83%E0%B8%AB%E0%B9%89-line-bot-%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%84%E0%B8%B8%E0%B8%93%E0%B8%95%E0%B8%B7%E0%B9%88%E0%B8%99%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%A0%E0%B8%A7%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B9%8C-4cb7da653274">@link
                      Webhook Events</a>
                    <div style="display: flex;" class="mt-3">
                      <div class="mb-0 pa-2 pl-0" style="font-weight: 900;">Endpoint</div>
                      <div class="mb-0 px-4 py-1"
                        style="align-items: center;background-color: black;color:white;display: flex;border-radius: 10px;">
                        <p class="mb-0 mr-3" style="color: orange;">POST</p>
                        https://api-beloyalty-productions.betaskthai.tech/video-activity/
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <div>
                      <div style="font-weight: 800;">Request headers</div>
                      <div style="" class="mb-3">
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p style="font-weight: 900;" class="mb-0">apiToken</p>
                          <p class="mb-0">ได้จากหลังกจากกดสร้าง token</p>
                        </div>
                      </div>
                    </div>
                    <v-divider style="margin-top: 1px !important;"></v-divider>
                    <div>
                      <div style="font-weight: 800;">Request Params</div>
                      <div style="" class="mb-3">
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mb-0" style="font-weight: 900;">lineUserId</p>
                          <p class="mb-0">userID ลูกค้า ได้จาก event webhook</p>
                        </div>
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mr-3 mb-0" style="font-weight: 900;">shopId</p>
                          <p class="mb-0">รหัสร้านค้า(destination) ได้จาก event webhook</p>
                        </div>
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mr-3 mb-0" style="font-weight: 900;">replyToken</p>
                          <p class="mb-0">token(replyToken) สำหรับส่งข้อความกลับได้จาก event webhook</p>
                        </div>
                      </div>
                    </div>
                    <v-divider style="margin-top: 1px !important;"></v-divider>
                    <div>
                      <div style="font-weight: 800;">Reponse</div>
                      <div>
                        <div class="mb-2">JSON</div>
                        <div class="mb-0 px-4 py-1"
                          style="background-color: black;color:white;display: flex;border-radius: 10px;">{ "status": true
                          }</div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="selected2.id === 3">
                    <h2 style="color: black;">POS api</h2>
                    - API service ที่ใช้สำหรับเพิ่มคะแนนให้ลูกค้า
                    <div style="display: flex;" class="mt-3">
                      <div class="mb-0 pa-2" style="font-weight: 900;">Endpoint</div>
                      <div class="mb-0 px-4 py-1"
                        style="align-items: center;background-color: black;color:white;display: flex;border-radius: 10px;">
                        <p class="mb-0 mr-3" style="color: orange;">POST</p>
                        https://api-beloyalty-productions.betaskthai.tech/merchant-point
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <div>
                      <div style="font-weight: 800;">Request headers</div>
                      <div style="" class="mb-3">
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p style="font-weight: 900;" class="mb-0">apiToken</p>
                          <p class="mb-0">ได้จากหลังกจากกดสร้าง token key</p>
                        </div>
                      </div>
                    </div>
                    <v-divider style="margin-top: 1px !important;"></v-divider>
                    <div>
                      <div style="font-weight: 800;">Request body</div>
                      <div style="" class="mb-3">
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mb-0" style="font-weight: 900;">exchangRateId</p>
                          <p class="mb-0">ID สินค้า/บริการ</p>
                        </div>
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mr-3 mb-0" style="font-weight: 900;">shopId</p>
                          <p class="mb-0">รหัสร้านค้า</p>
                        </div>
                        <div class="mb-0 pa-2 pb-0" style="display: flex;border-radius: 10px;">
                          <p class="mb-0 requried" style="color: orange;font-weight: 800;">Required</p>
                        </div>
                        <div class="mb-0 pa-2 pt-0">
                          <p class="mr-3 mb-0" style="font-weight: 900;">tel</p>
                          <p class="mb-0">เบอร์โทรลูกค้าที่สมัครสมาชิก</p>
                        </div>
                      </div>
                    </div>
                    <v-divider style="margin-top: 1px !important;"></v-divider>
                    <div>
                      <div style="font-weight: 800;">Reponse</div>
                      <div>
                        <div class="mb-2">JSON</div>
                        <div class="mb-0 px-4 py-1"
                          style="background-color: black;color:white;display: flex;border-radius: 10px;">{ "status": true
                          }</div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="selected2.id === 4">
                    <div style="width: 400px;display: flex;">
                      <v-switch v-model="formUpdate.zortStatus" @click="updateStatus"
                        :label="`สถานะการใช้งาน : ${formUpdate.zortStatus === 'false' ? 'ปิดใช้งาน' : 'เปิดใช้งาน'}`"></v-switch>
                    </div>
                    <div style="width: 400px;display: flex;">
                      <v-text-field v-model="formUpdate.zortStorename" outlined dense label="storename"></v-text-field>
                    </div>
                    <div style="width: 400px;display: flex;">
                      <v-text-field v-model="formUpdate.zortApikey" outlined dense label="apikey"></v-text-field>
                    </div>
                    <div style="width: 400px;display: flex;">
                      <v-text-field v-model="formUpdate.zortApisecret" outlined dense label="apisecret"></v-text-field>
                    </div>
                    <div style="width: 400px;display: flex;justify-content:center;">
                      <v-btn class="ma-2" color="#1b437c" dark @click="submitZort()">
                        บันทึก
                      </v-btn>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="selected2.id === 5">
                    <div style="width: 100%;display: flex;flex-direction: row;min-height: 40px">
                      <v-text-field v-model="link" style="border-radius: 8px 0 0 8px;width:350px;" solo readonly
                        ref="textToCopy" height="40" placeholder='กรุณาเปิดการใช้งาน'></v-text-field>
                      <v-btn min-height="40" elevation="2" x-large color="success" dark
                        style="border-radius: 0 8px 8px 0;min-height: 40px" @click="textToCopy()">คัดลอกลิงก์
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-scroll-y-transition>
            </v-col>
          </v-row>
        </v-card> -->
      <!-- </v-container> -->
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api

export default {
  data: () => ({
    zort: {
      id: '',
      name: 'Zort',
      storename: '',
      apikey: '',
      apisecret: '',
      shopId: '',
      CREATE_USER: '',
      LAST_USER: ''
    },
    loyverse: {
      id: '',
      name: 'loyverse',
      Access_token: '',
      shopId: '',
      CREATE_USER: '',
      LAST_USER: ''
    },

    linkZort: '',
    linkLoyverse: '',
    status: '',
    tab: null,
    items: [
      {
        name: 'ZORT',
        img: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2Fcropped-zort-logo-450.png?alt=media&token=7f7c434b-87c9-49e4-a773-19197b55f78b'
      },
      {
        name: 'Loyverse',
        img: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2F1392959436_loyverse-logo-v-1024x1024(1).png.1f11d94115aee89af8ef09d4f2b0b458.png?alt=media&token=4a477ebf-7451-4113-9956-bb761195ebdf'
      }
    ]
  }),
  async mounted () {
    console.log('session', this.session)
    this.shopId = this.$session.getAll().data.shopId
    this.linkZort = this.DNS_IP + '/betask/webhook/zort?shopId=' + this.$session.getAll().data.shopId
    // await this.getData()
    // await this.gatDataConZort()
    await this.getdataZort()
    await this.getdataLoyverse()
  },
  methods: {
    textToCopy () {
      let textToCopyLink = this.$refs.textToCopy.$el.querySelector('input')
      textToCopyLink.select()
      document.execCommand('copy')
      setTimeout(this.timeout, 2000)
      this.$swal('คัดลอกข้อมูล เรียบร้อย', '', 'success')
    },
    textToCopy2 () {
      let textToCopyLink = this.$refs.textToCopy2.$el.querySelector('input')
      textToCopyLink.select()
      document.execCommand('copy')
      setTimeout(this.timeout, 2000)
      this.$swal('คัดลอกข้อมูล เรียบร้อย', '', 'success')
    },
    getdataZort () {
      axios
        .get(this.DNS_IP + '/ConnectService/get?name=Zort&shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          const rs = res.data[0]
          if (res.data.status === false) {
            // console.log('ไม่มี')
          } else {
            this.zort.id = rs.id
            this.zort.name = rs.name
            if (rs.storename === 'None') {
              this.zort.storename = ''
            } else {
              this.zort.storename = rs.storename
            }
            if (rs.apikey === 'None') {
              this.zort.apikey = ''
            } else {
              this.zort.apikey = rs.apikey
            }
            if (rs.apisecret === 'None') {
              this.zort.apisecret = ''
            } else {
              this.zort.apisecret = rs.apisecret
            }
            console.log('aa', this.zort.storename, this.zort.apikey, this.zort.apisecret)
            // if ((this.zort.storename && this.zort.apikey && this.zort.apisecret !== '') === true) {
            //   console.log('fdf')
            // this.linkZort = this.DNS_IP + '/betask/webhook/zort?shopId=' + this.$session.getAll().data.shopId
            // } else {
            //   this.linkZort = ''
            // }
          }
        })
    },
    addZort () {
      delete this.zort['id']
      this.zort.CREATE_USER = this.$session.getAll().data.userName
      this.zort.LAST_USER = this.$session.getAll().data.userName
      this.zort.shopId = this.$session.getAll().data.shopId
      axios
        .post(this.DNS_IP + '/ConnectService/add', this.zort)
        .then(res => {
          this.$swal('บันทึกเรียบร้อย', '', 'success')
          setTimeout(() => {
            this.$swal.close()
          }, 2000)
          this.getdataZort()
          console.log('res=> ', res.data)
        })
    },
    updateZort () {
      if (this.zort.storename === '') {
        this.zort.storename = null
      }
      if (this.zort.apikey === '') {
        this.zort.apikey = null
      }
      if (this.zort.apisecret === '') {
        this.zort.apisecret = null
      }
      const id = this.zort.id
      this.zort.CREATE_USER = this.$session.getAll().data.userName
      this.zort.LAST_USER = this.$session.getAll().data.userName
      axios
        .post(this.DNS_IP + '/ConnectService/edit/' + id, this.zort)
        .then(res => {
          this.$swal('บันทึกเรียบร้อย', '', 'success')
          setTimeout(() => {
            this.$swal.close()
          }, 2000)
          this.getdataZort()
        })
    },
    submitZort () {
      axios
        .get(this.DNS_IP + '/ConnectService/get?name=Zort&shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          if (res.data.status === false) {
            this.addZort()
          } else {
            this.updateZort()
          }
        })
    },
    getdataLoyverse () {
      axios
        .get(this.DNS_IP + '/ConnectService/get?name=loyverse&shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          const rs = res.data[0]
          if (res.data.status === false) {
          } else {
            this.loyverse.id = rs.id
            this.loyverse.name = rs.name
            if (rs.Access_token === 'None') {
              this.loyverse.Access_token = ''
            } else {
              this.loyverse.Access_token = rs.Access_token
            }

            if ((this.loyverse.Access_token !== '') === true) {
              this.linkLoyverse = this.DNS_IP + '/betask/webhook/loyverse?shopId=' + this.$session.getAll().data.shopId
            } else {
              this.linkLoyverse = ''
            }
          }
        })
    },
    addLoyverse () {
      delete this.loyverse['id']
      this.loyverse.CREATE_USER = this.$session.getAll().data.userName
      this.loyverse.LAST_USER = this.$session.getAll().data.userName
      this.loyverse.shopId = this.$session.getAll().data.shopId
      axios
        .post(this.DNS_IP + '/ConnectService/add', this.loyverse)
        .then(res => {
          this.$swal('บันทึกเรียบร้อย', '', 'success')
          setTimeout(() => {
            this.$swal.close()
          }, 2000)
          this.getdataLoyverse()
          console.log('res=> ', res.data)
        })
    },
    updateLoyverse () {
      if (this.loyverse.Access_token === '') {
        this.loyverse.Access_token = null
      }
      const id = this.loyverse.id
      this.zort.CREATE_USER = this.$session.getAll().data.userName
      this.zort.LAST_USER = this.$session.getAll().data.userName
      axios
        .post(this.DNS_IP + '/ConnectService/edit/' + id, this.loyverse)
        .then(res => {
          this.$swal('บันทึกเรียบร้อย', '', 'success')
          setTimeout(() => {
            this.$swal.close()
          }, 2000)
          this.getdataLoyverse()
        })
    },
    submitLoyverse () {
      axios
        .get(this.DNS_IP + '/ConnectService/get?name=Loyverse&shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          if (res.data.status === false) {
            this.addLoyverse()
          } else {
            this.updateLoyverse()
          }
        })
    }
    // async getData () {
    //   await axios
    //     .get(this.DNS_IP + '/only_shop/getID?shopId=' + this.$session.getAll().data.shopId)
    //     .then(res => {
    //       console.log(res.data)
    //       if (res.data.status !== false) {
    //         console.log('this.1111', res.data.status)
    //       }
    //       this.apiToken = res.data.apiToken
    //       console.log('this.formUpdate', this.apiToken)
    //     })
    // },
    // async createToken () {
    //   console.log('sss')
    //   let message = this.apiToken ? 'ต้องการสร้าง token ใหม่ใช่หรือไม่' : 'ต้องการสร้าง token ใช่หรือไม่'
    //   this.$swal({
    //     title: message,
    //     type: 'question',
    //     showCancelButton: true,
    //     confirmButtonColor: 'rgb(77 127 210)',
    //     cancelButtonColor: '#b3b1ab',
    //     confirmButtonText: 'ใช่',
    //     cancelButtonText: 'ไม่'
    //   }).then(async result => {
    //     const today = new Date()
    //     const date =
    //       today.getFullYear() +
    //       '' +
    //       (today.getMonth() + 1) +
    //       '' +
    //       today.getDate()
    //     const time =
    //       today.getHours() +
    //       '' +
    //       today.getMinutes() +
    //       '' +
    //       today.getSeconds()
    //     const token = date + '' + time
    //     var md5 = require('md5')
    //     var tokenKey = md5(token)
    //     console.log('tokenKey', tokenKey)
    //     let data = {
    //       apiToken: tokenKey
    //     }
    //     console.log('data', data)
    //     await axios
    //       .post(this.DNS_IP + '/system_shop/edit/' + this.$session.getAll().data.shopId, data)
    //       .then(async response => {
    //         // Debug response
    //         this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
    //         this.apiToken = tokenKey
    //       })
    //       .catch(error => {
    //         console.log('error function addDataGlobal : ', error)
    //       })
    //   })
    // },
    // gatDataConZort () {
    //   axios
    //     .get(this.DNS_IP + '/only_shop/getID?shopId=' + this.$session.getAll().data.shopId)
    //     .then(res => {
    //       if (res.data.status === false) {
    //         this.formUpdate.zortStatus = 'False'
    //         this.formUpdate.zortStorename = ''
    //         this.formUpdate.zortApikey = ''
    //         this.formUpdate.zortApisecret = ''
    //       } else {
    //         if (this.formUpdate.zortStatus === 'False') {
    //           this.link = ''
    //           this.formUpdate.zortStorename = res.data.zortStorename
    //           this.formUpdate.zortApikey = res.data.zortApikey
    //           this.formUpdate.zortApisecret = res.data.zortApisecret
    //           this.status = this.formUpdate.zortStatus
    //         } else {
    //           this.formUpdate.zortStorename = res.data.zortStorename
    //           this.formUpdate.zortApikey = res.data.zortApikey
    //           this.formUpdate.zortApisecret = res.data.zortApisecret
    //           this.status = this.formUpdate.zortStatus
    //           if (this.formUpdate.zortStorename && this.formUpdate.zortApikey && this.formUpdate.zortApisecret !== '') {
    //             this.link = this.DNS_IP + '/betask/webhook/zort?shopId=' + this.$session.getAll().data.shopId
    //           } else {
    //             this.link = ''
    //           }
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       console.log('error function editDataGlobal : ', error)
    //     })
    // },
    // submitZort () {
    //   const dt = {
    //     zortStorename: this.formUpdate.zortStorename,
    //     zortApikey: this.formUpdate.zortApikey,
    //     zortApisecret: this.formUpdate.zortApisecret
    //   }
    //   axios
    //     .post(this.DNS_IP + '/system_shop/edit_data/' + this.$session.getAll().data.shopId, dt)
    //     .then(resule => {
    //       this.$swal('บันทึกเรียบร้อย', '', 'success')
    //       this.gatDataConZort()
    //       console.log('re', resule.data)
    //     })
    // },
    // async updateStatus () {
    //   if (this.formUpdate.zortStatus === 'True') {
    //     this.formUpdate.zortStatus = 'False'
    //   } else {
    //     this.formUpdate.zortStatus = 'True'
    //   }
    //   const data = {
    //     zortStatus: this.formUpdate.zortStatus
    //   }

    //   axios
    //     .post(this.DNS_IP + '/system_shop/edit_data/' + this.$session.getAll().data.shopId, data)
    //     .then(resule => {
    //       if (resule.data.status === true) {
    //         if (this.formUpdate.zortStatus === 'True') {
    //           this.link = this.DNS_IP + '/betask/webhook/zort?shopId=' + this.$session.getAll().data.shopId
    //           // this.formUpdate.zortStatus = 'True'
    //           this.$swal('เปิดการใช้งานเรียบร้อย', '', 'success')
    //           this.gatDataConZort()
    //         } else if (this.formUpdate.zortStatus === 'False') {
    //           // this.formUpdate.zortStatus = 'False'
    //           this.link = ''
    //           this.$swal('ปิดการใช้งานเรียบร้อย', '', 'success')
    //           this.gatDataConZort()
    //         }
    //       }
    //       console.log('resule', this.formUpdate.zortStatus)
    //     })
    //   // await this.gatDataConZort()
    //   // await this.getLink()
    // },
    // insertAll () {
    //   axios
    //     .get(this.DNS_IP + '/ConnectService/get?name=Zort&shopId=' + this.shopId)
    // },

    // getLink () {
    //   if (this.status === 'True') {

    //   } else {
    //     this.link = ''
    //   }
    // },
    // submitData () {
    //   axios
    //     .get(this.DNS_IP + '/ConnectService/get?name=Zort&shopId=' + this.shopId)
    //     .then(res => {
    //       if (res.data.length > 0) {
    //         const id = res.data[0].id
    //         // update
    //         const dt = {
    //           zortStorename: this.formUpdate.zortStorename,
    //           zortApikey: this.formUpdate.zortApikey,
    //           zortApisecret: this.formUpdate.zortApisecret
    //         }
    //         axios
    //           .post(this.DNS_IP + '/ConnectService/edit/' + id, dt)
    //           .then(resule => {
    //             this.$swal('บันทึกเรียบร้อย', '', 'success')
    //           })
    //       } else {
    //         const dt = {
    //           zortStorename: this.formUpdate.zortStorename,
    //           zortApikey: this.formUpdate.zortApikey,
    //           zortApisecret: this.formUpdate.zortApisecret
    //         }
    //         // add
    //         axios
    //           .post(this.DNS_IP + '/ConnectService/add', dt)
    //           .then(resule => {
    //             this.$swal('บันทึกเรียบร้อย', '', 'success')
    //           })
    //       }
    //     })
    // },
    // getDataConnectService () {
    //   axios
    //     .get(this.DNS_IP + '/ConnectService/get?shopId=' + this.shopId)
    //     .then(res => {
    //       // console.log('res=>', res.data)
    //       this.formUpdate.id = res.data[0].id
    //       this.formUpdate.name = res.data[0].name
    //       if (res.data[0].storename === 'None') {
    //         this.formUpdate.storename = ''
    //       } else {
    //         this.formUpdate.storename = res.data[0].storename
    //       }
    //       if (res.data[0].apisecret === 'None') {
    //         this.formUpdate.apisecret = ''
    //       } else {
    //         this.formUpdate.apisecret = res.data[0].apisecret
    //       }
    //       if (res.data[0].apikey === 'None') {
    //         this.formUpdate.apikey = ''
    //       } else {
    //         this.formUpdate.apikey = res.data[0].apikey
    //       }
    //       this.formUpdate.zortStatus = res.data[0].zortStatus
    //       if (this.formUpdate.storename && this.formUpdate.apikey && this.formUpdate.apisecret !== '') {
    //         this.link = this.DNS_IP + '/betask/webhook/zort?shopId=' + this.$session.getAll().data.shopId
    //       } else {
    //         this.link = ''
    //       }
    //       console.log(this.formUpdate)
    //     })
    // },
    // insertConnectService () {
    //   delete this.formUpdate['id']
    //   this.formUpdate.shopId = this.shopId
    //   this.formUpdate.name = 'Zort'
    //   axios
    //     .post(this.DNS_IP + '/ConnectService/add', this.formUpdate)
    //     .then(res => {
    //       console.log('insert')
    //       this.$swal('บันทึกเรียบร้อย', '', 'success')
    //       this.getDataConnectService()
    //     })
    // },
    // updateConnectService () {
    //   const id = this.formUpdate.id
    //   if (this.formUpdate.storename === '') {
    //     this.formUpdate.storename = null
    //   }
    //   if (this.formUpdate.apisecret === '') {
    //     this.formUpdate.apisecret = null
    //   }
    //   if (this.formUpdate.apikey === '') {
    //     this.formUpdate.apikey = null
    //   }
    //   delete this.formUpdate['Access_token']
    //   axios
    //     .post(this.DNS_IP + '/ConnectService/edit/' + id, this.formUpdate)
    //     .then(res => {
    //       console.log('update')
    //       this.$swal('บันทึกเรียบร้อย', '', 'success')
    //       this.getDataConnectService()
    //     })
    // },
    // checkProcess () {
    //   axios
    //     .get(this.DNS_IP + '/ConnectService/get?name=Zort&shopId=' + this.shopId)
    //     .then(res => {
    //       if (res.data.status === false) {
    //         this.insertConnectService()
    //       } else {
    //         this.updateConnectService()
    //       }
    //     })
    // },
    // inseertLoyverse () {
    //   delete this.formUpdate['id']
    //   this.formUpdate.shopId = this.shopId
    //   this.formUpdate.name = 'Loyverse'
    //   delete this.formUpdate['storename']
    //   delete this.formUpdate['apikey']
    //   delete this.formUpdate['apisecret']
    //   axios
    //     .post(this.DNS_IP + '/ConnectService/add', this.formUpdate)
    //     .then(res => {
    //       console.log('insert')
    //       this.$swal('บันทึกเรียบร้อย', '', 'success')
    //       this.getDataConnectService()
    //     })
    // },
    // checkProcessLoyverse () {
    //   axios
    //     .get(this.DNS_IP + '/ConnectService/get?name=Loyverse&shopId=' + this.shopId)
    //     .then(res => {
    //       if (res.data.status === false) {
    //         this.inseertLoyverse()
    //       } else {
    //       }
    //     })
    // }
  }
}

</script>
<style scoped>
.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #f2f4f9 !important;
}

.padding-colH {
  padding: 5px 15px 0px;
}

.v-expansion-panel-header {
  background-color: white !important;
  color: black !important;
  font-weight: bold !important;
}

.text-all {
  display: flex;
  align-items: center;
}

.requried {
  font-weight: 800;
  border: solid;
  font-size: 12px;
  padding-left: 2px;
  padding-right: 2px;
  border-radius: 10px;
}

.v-btn:not(.v-btn--round).v-size--x-large {
  height: 48px !important;
  max-width: 110px !important;
  padding: 0 23.1111111111px;
}

/* //////////////////////////  */
.v-application--is-ltr .v-tabs--align-with-title>.v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)>.v-slide-group__wrapper>.v-tabs-bar__content>.v-tab:first-child,
.v-application--is-ltr .v-tabs--align-with-title>.v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)>.v-slide-group__wrapper>.v-tabs-bar__content>.v-tabs-slider-wrapper+.v-tab {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/ApiReference.vue